export default __webpack_public_path__ + "static/media/greenside-app.df80ed9e.png";